/** Floating help widget copy — all supported locales. */
export const helpAgentStrings = {
  en: {
    bubble: "Need help?",
    title: "Request a callback",
    subtitle: "Leave your details and our team will call you back.",
    name: "Your name",
    email: "Email",
    phone: "Phone number",
    submit: "Request callback",
    submitting: "Sending…",
    successTitle: "Request received",
    successBody: "Thank you. We will call you back soon.",
    close: "Close",
    required: "Please fill all fields",
    ariaLabel: "Need help — request a callback",
  },
  hi: {
    bubble: "क्या आपको मदद चाहिए?",
    title: "कॉलबैक का अनुरोध",
    subtitle: "अपना विवरण छोड़ें, हमारी टीम आपको वापस कॉल करेगी।",
    name: "आपका नाम",
    email: "ईमेल",
    phone: "फ़ोन नंबर",
    submit: "कॉलबैक अनुरोध करें",
    submitting: "भेजा जा रहा है…",
    successTitle: "अनुरोध प्राप्त",
    successBody: "धन्यवाद। हम जल्द ही आपको कॉल करेंगे।",
    close: "बंद करें",
    required: "सभी फ़ील्ड भरें",
    ariaLabel: "मदद — कॉलबैक अनुरोध",
  },
  bn: {
    bubble: "সাহায্য দরকার?",
    title: "কলব্যাক অনুরোধ",
    subtitle: "আপনার তথ্য দিন, আমাদের টিম আপনাকে ফোন করবে।",
    name: "আপনার নাম",
    email: "ইমেইল",
    phone: "ফোন নম্বর",
    submit: "কলব্যাক অনুরোধ",
    submitting: "পাঠানো হচ্ছে…",
    successTitle: "অনুরোধ গৃহীত",
    successBody: "ধন্যবাদ। আমরা শীঘ্রই কল করব।",
    close: "বন্ধ",
    required: "সব ঘর পূরণ করুন",
    ariaLabel: "সাহায্য — কলব্যাক",
  },
  mr: {
    bubble: "मदत हवी आहे?",
    title: "कॉलबॅक विनंती",
    subtitle: "तुमची माहिती द्या, आमची टीम तुम्हाला कॉल करेल.",
    name: "तुमचे नाव",
    email: "ईमेल",
    phone: "फोन नंबर",
    submit: "कॉलबॅक विनंती",
    submitting: "पाठवत आहे…",
    successTitle: "विनंती मिळाली",
    successBody: "धन्यवाद. लवकरच कॉल करू.",
    close: "बंद",
    required: "सर्व फील्ड भरा",
    ariaLabel: "मदत — कॉलबॅक",
  },
  te: {
    bubble: "మీకు సహాయం కావాలా?",
    title: "కాల్‌బ్యాక్ అభ్యర్థన",
    subtitle: "మీ వివరాలు ఇవ్వండి, మా బృందం మిమ్మల్ని కాల్ చేస్తుంది.",
    name: "మీ పేరు",
    email: "ఇమెయిల్",
    phone: "ఫోన్ నంబర్",
    submit: "కాల్‌బ్యాక్ అభ్యర్థించండి",
    submitting: "పంపుతోంది…",
    successTitle: "అభ్యర్థన స్వీకరించబడింది",
    successBody: "ధన్యవాదాలు. మేము త్వరలో కాల్ చేస్తాము.",
    close: "మూసివేయి",
    required: "అన్ని ఫీల్డ్‌లు పూరించండి",
    ariaLabel: "సహాయం — కాల్‌బ్యాక్",
  },
  ta: {
    bubble: "உதவி வேண்டுமா?",
    title: "திரும்ப அழைக்க கோரிக்கை",
    subtitle: "உங்கள் விவரங்களை விடுங்கள், எங்கள் குழு உங்களை அழைக்கும்.",
    name: "உங்கள் பெயர்",
    email: "மின்னஞ்சல்",
    phone: "தொலைபேசி எண்",
    submit: "திரும்ப அழைக்க கோருங்கள்",
    submitting: "அனுப்புகிறது…",
    successTitle: "கோரிக்கை பெறப்பட்டது",
    successBody: "நன்றி. விரைவில் அழைப்போம்.",
    close: "மூடு",
    required: "அனைத்து புலங்களையும் நிரப்பவும்",
    ariaLabel: "உதவி — திரும்ப அழை",
  },
  kn: {
    bubble: "ನಿಮಗೆ ಸಹಾಯ ಬೇಕೇ?",
    title: "ಕಾಲ್‌ಬ್ಯಾಕ್ ವಿನಂತಿ",
    subtitle: "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಬಿಡಿ, ನಮ್ಮ ತಂಡ ನಿಮಗೆ ಕರೆ ಮಾಡುತ್ತದೆ.",
    name: "ನಿಮ್ಮ ಹೆಸರು",
    email: "ಇಮೇಲ್",
    phone: "ಫೋನ್ ಸಂಖ್ಯೆ",
    submit: "ಕಾಲ್‌ಬ್ಯಾಕ್ ವಿನಂತಿಸಿ",
    submitting: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
    successTitle: "ವಿನಂತಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
    successBody: "ಧನ್ಯವಾದ. ಶೀಘ್ರದಲ್ಲೇ ಕರೆ ಮಾಡುತ್ತೇವೆ.",
    close: "ಮುಚ್ಚಿ",
    required: "ಎಲ್ಲಾ ಫೀಲ್ಡ್‌ಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ",
    ariaLabel: "ಸಹಾಯ — ಕಾಲ್‌ಬ್ಯಾಕ್",
  },
  ml: {
    bubble: "സഹായം വേണോ?",
    title: "കോൾബാക്ക് അഭ്യർത്ഥന",
    subtitle: "നിങ്ങളുടെ വിവരങ്ങൾ നൽകുക, ഞങ്ങളുടെ ടീം വിളിക്കും.",
    name: "നിങ്ങളുടെ പേര്",
    email: "ഇമെയിൽ",
    phone: "ഫോൺ നമ്പർ",
    submit: "കോൾബാക്ക് അഭ്യർത്ഥിക്കുക",
    submitting: "അയയ്ക്കുന്നു…",
    successTitle: "അഭ്യർത്ഥന സ്വീകരിച്ചു",
    successBody: "നന്ദി. ഞങ്ങൾ ഉടൻ വിളിക്കും.",
    close: "അടയ്ക്കുക",
    required: "എല്ലാ ഫീൽഡുകളും പൂരിപ്പിക്കുക",
    ariaLabel: "സഹായം — കോൾബാക്ക്",
  },
  pa: {
    bubble: "ਕੀ ਤੁਹਾਨੂੰ ਮਦਦ ਚਾਹੀਦੀ ਹੈ?",
    title: "ਕਾਲਬੈਕ ਬੇਨਤੀ",
    subtitle: "ਆਪਣੇ ਵੇਰਵੇ ਛੱਡੋ, ਸਾਡੀ ਟੀਮ ਤੁਹਾਨੂੰ ਕਾਲ ਕਰੇਗੀ।",
    name: "ਤੁਹਾਡਾ ਨਾਮ",
    email: "ਈਮੇਲ",
    phone: "ਫੋਨ ਨੰਬਰ",
    submit: "ਕਾਲਬੈਕ ਬੇਨਤੀ ਕਰੋ",
    submitting: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ…",
    successTitle: "ਬੇਨਤੀ ਮਿਲੀ",
    successBody: "ਧੰਨਵਾਦ। ਅਸੀਂ ਜਲਦੀ ਕਾਲ ਕਰਾਂਗੇ।",
    close: "ਬੰਦ",
    required: "ਸਾਰੇ ਖੇਤਰ ਭਰੋ",
    ariaLabel: "ਮਦਦ — ਕਾਲਬੈਕ",
  },
};

export const callbackStatuses = ["new", "contacted", "closed"];

export const callbackStatusLabels = {
  en: { new: "New", contacted: "Contacted", closed: "Closed" },
  hi: { new: "नया", contacted: "संपर्क किया", closed: "बंद" },
  bn: { new: "নতুন", contacted: "যোগাযোগ", closed: "বন্ধ" },
  mr: { new: "नवीन", contacted: "संपर्क", closed: "बंद" },
  te: { new: "కొత్త", contacted: "సంప్రదించారు", closed: "మూసివేయి" },
  ta: { new: "புதிய", contacted: "தொடர்பு", closed: "மூடப்பட்டது" },
  kn: { new: "ಹೊಸ", contacted: "ಸಂಪರ್ಕ", closed: "ಮುಚ್ಚಲಾಗಿದೆ" },
  ml: { new: "പുതിയ", contacted: "ബന്ധപ്പെട്ടു", closed: "അടച്ചു" },
  pa: { new: "ਨਵਾਂ", contacted: "ਸੰਪਰਕ", closed: "ਬੰਦ" },
};

export const callbackStatusLabel = (lang, code) =>
  callbackStatusLabels[lang]?.[code] || callbackStatusLabels.en[code] || code;
